import { packages } from '@shared/api/services'
import { queryClient } from '@shared/api/query-client'
import { useMutation } from '@tanstack/react-query'

export const useUpdateProfilePackage = (onSuccess = () => {}) => {
	return useMutation({
		mutationFn: packages.updateProfilePackage,
		onSuccess: () => {
			queryClient.invalidateQueries(['profile-packages'])
			onSuccess()
		},
	})
}
